import React from "react";
import BaseEmailComponent from "../BaseEmailComponent";
import { Form } from "react-bootstrap";

const CenteredHeading = ({ id, data, onUpdate, styleSettings }) => {
  // Edit UI with forms for title and description
  const renderEditUI = ({ title, setTitle, description, setDescription, handleSaveChanges, styleSettings }) => {
    // Function to save all changes at once
    const saveAllChanges = () => {
      handleSaveChanges(title, description);
    };

    return (
      <div className="p-3 rounded" style={{ backgroundColor: 'white' }}>
        <Form.Group className="mb-3">
          <Form.Label><strong>Heading</strong></Form.Label>
          <Form.Control
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onBlur={saveAllChanges}
            placeholder="Enter Heading"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label><strong>Description</strong></Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            onBlur={saveAllChanges}
            placeholder="Enter Description"
          />
        </Form.Group>
      </div>
    );
  };

  // View UI for display mode with centered alignment
  const renderViewUI = ({ title, description, styleSettings }) => {
    const { primaryColor, secondaryColor, fontFamily } = styleSettings || {};

    return (
      <div className="py-4 text-center">
        <h2 style={{ 
          fontSize: "28px", 
          marginBottom: "16px",
          color: secondaryColor || "#a1894c",
          fontFamily,
          fontWeight: "bold"
        }}>
          {title}
        </h2>
        <div className="description-text" style={{ 
          fontFamily,
          color: primaryColor || "#333333",
          lineHeight: "1.6",
          fontSize: "16px",
          maxWidth: "800px",
          margin: "0 auto"
        }}>
          {description}
        </div>
      </div>
    );
  };

  return (
    <BaseEmailComponent
      id={id}
      data={data}
      onUpdate={onUpdate}
      componentName="Centered Heading"
      styleSettings={styleSettings}
      editUI={renderEditUI}
      viewUI={renderViewUI}
    />
  );
};

export default CenteredHeading; 